import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const getProducts = (category) =>
  api.get("/products", { params: category && category !== "all" ? { category } : {} }).then((r) => r.data);

export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);

export const getConfig = () => api.get("/config").then((r) => r.data);

export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);

export const submitQuote = (data) => api.post("/quote", data).then((r) => r.data);

export const createStripeSession = (data) =>
  api.post("/payments/stripe/create-session", data).then((r) => r.data);

export const getStripeStatus = (sessionId) =>
  api.get(`/payments/stripe/status/${sessionId}`).then((r) => r.data);

export const initializePaystack = (data) =>
  api.post("/payments/paystack/initialize", data).then((r) => r.data);

export const verifyPaystack = (reference) =>
  api.get(`/payments/paystack/verify/${reference}`).then((r) => r.data);

export const getOrder = (orderId) => api.get(`/orders/${orderId}`).then((r) => r.data);

export const referralSignup = (data) => api.post("/referrals/signup", data).then((r) => r.data);

export const getReferralStats = (code) => api.get(`/referrals/${code}`).then((r) => r.data);

export const getReferralLeaderboard = () => api.get("/referrals-leaderboard").then((r) => r.data);

export const adminApi = (token) =>
  axios.create({
    baseURL: API,
    headers: { Authorization: `Bearer ${token}` },
  });
